import { Control, FieldValues, Path } from "react-hook-form";
import styled from "styled-components";

import { Larger } from "@/components/Forms";
import Switch from "@/components/Switch";
import Text from "@/components/Text";

const Field = styled(Larger)`
  padding: 18px 12px;
  border: 1px solid ${({ theme }) => theme.colors.grayscale};
  border-radius: 4px;
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 0 5px;
`;

const Description = styled(Text)`
  padding-right: 40px;
`;

interface Props<T extends FieldValues> {
  name: Path<T>;
  control: Control<T>;
  description: string;
}

const RestrictionsField = <T extends FieldValues>({
  name,
  control,
  description,
}: Props<T>) => {
  return (
    <Field>
      <Header>
        <Text $type="smallHeadline">Access restrictions</Text>
        <Switch<T> name={name} control={control} />
      </Header>
      <Description $color="gray" $type="smallNormal">
        {description}
      </Description>
    </Field>
  );
};

export default RestrictionsField;
